export const BigWins = ({ width = '30', height = '31' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 3.5C23.3344 3.5 23.9959 4.17694 24.0002 4.98962L23.9908 5.16565L23.841 6.4985L25.5 6.5L25.6749 6.51009C26.3636 6.59007 26.9099 7.13645 26.9899 7.82507L27 8V11L26.9931 11.3253C26.8491 14.6982 24.4775 17.4943 21.312 18.2796C20.5325 19.3312 19.5206 20.21 18.3407 20.8372L17.9985 21.008V24.4985L22.5 24.5C23.3284 24.5 24 25.1716 24 26C24 26.8284 23.3284 27.5 22.5 27.5H7.5C6.67157 27.5 6 26.8284 6 26C6 25.1716 6.67157 24.5 7.5 24.5L11.9985 24.4985V21.008L11.6727 20.8443C10.487 20.2166 9.4703 19.3351 8.68586 18.2779C5.52251 17.4943 3.15088 14.6982 3.00693 11.3253L3 11V8C3 7.23075 3.57906 6.59674 4.32507 6.51009L4.5 6.5L6.1575 6.4985L6.00917 5.16565C5.91703 4.33634 6.51677 3.60411 7.32402 3.51016L7.5 3.5H22.5ZM9 9.5H6V11C6 13.3965 7.87338 15.3555 10.2356 15.4924L10.5 15.5V11C10.5 10.2307 9.92094 9.59674 9.17493 9.51009L9 9.5ZM24 9.5H21L20.8251 9.51009C20.1364 9.59007 19.5901 10.1364 19.5101 10.8251L19.5 11V15.5L19.7644 15.4924C22.0391 15.3606 23.8606 13.5391 23.9924 11.2644L24 11V9.5Z"
        fill="white"
      />
    </svg>
  );
};
